module.exports = __webpack_public_path__ + "img/01.b8a2c46a.jpg";